var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreeDotsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.625 15.0547C12.625 16.6053 13.8869 17.8672 15.4375 17.8672C16.9881 17.8672 18.25 16.6053 18.25 15.0547C18.25 13.5041 16.9881 12.2422 15.4375 12.2422C13.8869 12.2422 12.625 13.5041 12.625 15.0547Z",
    fill: "#222222",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.625 24.4297C12.625 25.9803 13.8869 27.2422 15.4375 27.2422C16.9881 27.2422 18.25 25.9803 18.25 24.4297C18.25 22.8791 16.9881 21.6172 15.4375 21.6172C13.8869 21.6172 12.625 22.8791 12.625 24.4297Z",
    fill: "#222222",
    fillOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.625 5.67969C12.625 7.23031 13.8869 8.49219 15.4375 8.49219C16.9881 8.49219 18.25 7.23031 18.25 5.67969C18.25 4.12906 16.9881 2.86719 15.4375 2.86719C13.8869 2.86719 12.625 4.12906 12.625 5.67969Z",
    fill: "#222222",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDotsIcon);
export default __webpack_public_path__ + "static/media/threeDotsIcon.312187a7f4d64ec5a11206edda1182f6.svg";
export { ForwardRef as ReactComponent };